export default {
    "created": "Oferta de produse a fost creata cu succes",
    "updated": "Oferta de produse a fost actualizata cu succes",
    "deleted": "Oferta de produse a fost ștearsa cu succes",
    "restored": "Oferta de produse a fost restaurata cu succes",
}
